import axios from 'axios';

const getFileName = (url: string): string => {
  const segments = url.split('/');

  return segments[segments.length - 1];
};

/** Downloads the image at `url` and wraps it in a File named after the last segment of the URL. */
export const imageToFile = async (url: string): Promise<File> => {
  try {
    const response = await axios.get(url, { responseType: 'blob' });

    if (response.status !== 200) throw new Error('Failed to retrieve the image.');

    const blob: Blob = response.data;

    return new File([blob], getFileName(url), { type: blob.type, lastModified: Date.now() });
  } catch (error) {
    throw new Error('Error: ' + (error as Error).message);
  }
};
